/* eslint-disable react/display-name */
import { forwardRef } from 'react'
import clsx from 'clsx'

type IProps = {
  classes?: string
  handleClick?: () => void
}

type Ref = HTMLDivElement

const Avatar = forwardRef<Ref, IProps>(({ classes, handleClick }, ref) => {
  return (
    <div
      ref={ref}
      className={clsx(`${classes}`, 'w-10 h-10 text-gray-400 duration-200 ease-in-out')}
      onClick={handleClick}
    >
      <svg
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        fill='currentColor'
        height='100%'
        width='100%'
      >
        <path
          d='M507.36 103C279.84 103 94.73 288.12 94.73 515.66a422.41 422.41 0 0 0 6.48 70.61c0 0.14 0.25 0.08 0.3 0.2a13.58 13.58 0 0 0 13 10.06 13.76 13.76 0 0 0 13.75-13.76 11.88 11.88 0 0 0-0.27-1.32l0.24-0.11a386 386 0 0 1-6-65.66c0-212.7 172.43-385.13 385.12-385.13S892.49 303 892.49 515.68 720.06 900.8 507.36 900.8c-142.14 0-266-77.22-332.69-191.79 0-0.07-0.09-0.11-0.11-0.18-0.18-0.3-0.38-0.59-0.55-0.89a13.61 13.61 0 0 0-12-7.37 13.76 13.76 0 0 0-13.75 13.75 13.42 13.42 0 0 0 2.74 7.83l-0.23 0.14c71.53 123 204.41 206 356.61 206C734.89 928.29 920 743.2 920 515.66S734.89 103 507.36 103z'
          fill='currentColor'
        />
        <path
          d='M507.37 570.43c82.32 0 149.31 67 149.31 149.31h27.51c0-97.49-79.32-176.82-176.82-176.82s-176.83 79.33-176.83 176.82h27.51c0-82.33 66.95-149.31 149.32-149.31z'
          fill='currentColor'
        />
        <path
          d='M344.29 719.74m-13.75 0a13.75 13.75 0 1 0 27.5 0 13.75 13.75 0 1 0-27.5 0Z'
          fill='currentColor'
        />
        <path
          d='M670.43 719.74m-13.75 0a13.75 13.75 0 1 0 27.5 0 13.75 13.75 0 1 0-27.5 0Z'
          fill='currentColor'
        />
        <path
          d='M531.854464 448.620636m-76.926146 76.926147a108.79 108.79 0 1 0 153.852293-153.852294 108.79 108.79 0 1 0-153.852293 153.852294Z'
          fill='currentColor'
          opacity='0.3'
        />
        <path
          d='M507.36 570.42c-75.15 0-136.29-61.14-136.29-136.3s61.14-136.3 136.29-136.3 136.3 61.15 136.3 136.3-61.14 136.3-136.3 136.3z m0-245.09a108.8 108.8 0 1 0 108.8 108.79 108.92 108.92 0 0 0-108.8-108.79z'
          fill='currentColor'
        />
      </svg>
    </div>
  )
})

export default Avatar
